<template>
  <Dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :title="$t('poolParty.record.detailTitle')"
    size="large"
  >
    <div class="reward-detail-dialog" :class="cssType">
      <div
        class="row"
        v-for="day in dailyRewardConfigList"
        :key="day.dayIndex"
      >
        <div class="day-col">
          {{ $t('poolParty.dailyReward.day', { day: day.dayIndex }) }}
        </div>
        <div class="reward-col">
          <div
            class="reward-item"
            v-for="(prop, index) in day.gameProps"
            :key="`${day.dayIndex}-${prop.propId}-${index}`"
          >
            <div class="icon-wrap">
              <div class="prop-icon" :class="`icon-${prop.propId}`"></div>
            </div>
            <span class="reward-text">
              {{ $t(`poolParty.prop.${prop.propId}`) }} * {{ prop.count }}
            </span>
          </div>
          <div class="reward-item">
            <div class="icon-wrap">
              <div class="prop-icon icon-random">?</div>
            </div>
            <span class="reward-text" :class="[3, 7].includes(day.dayIndex) ? 'not-owned' : 'owned'">
              {{ $t([3, 7].includes(day.dayIndex) ? 'poolParty.accumReward.randomPropNotOwned' : 'poolParty.accumReward.randomProp') }} * 1
            </span>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits, inject } from 'vue'
import Dialog from '@/components/Dialog/ActPoolParty/index.vue'
import { isMobile } from '@/utils'

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['update:modelValue'])

const cssType = isMobile ? 'mobile' : 'pc'
const globalConf = inject('globalConf')
const dailyRewardConfigList = computed(() => globalConf.value?.dailyRewardConfigList || [])
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
